const parent = {
  postMessage(message, targetOrigin, transfer) {
    if (window.parent) {
      window.parent.postMessage(message, targetOrigin, transfer)
    }
  },
}

export default parent
